<bk-auth-layout
  eyebrow="Admin console"
  heading="Sign in"
  sub="Use the account your administrator set up for you."
>
  @if (notice; as n) {
    <div class="bk-auth-note" data-tone="wait" role="status">
      <span class="bk-auth-dot" aria-hidden="true"></span>
      <div class="bk-auth-note__body">
        <p class="bk-auth-note__title">{{ n.title }}</p>
        <p class="bk-auth-note__quiet">{{ n.message }}</p>
      </div>
    </div>
  }

  <!-- Stays until the next submit; role=alert is announced on insert -->
  @if (error) {
    <div class="bk-auth-note" data-tone="bad" role="alert" id="signin-error">
      <span class="bk-auth-dot" aria-hidden="true"></span>
      <div class="bk-auth-note__body">
        <p class="bk-auth-note__title">{{ error.title }}</p>
        <p class="bk-auth-note__quiet">{{ error.message }}</p>
        @if (error.offerReset) {
          <a class="bk-auth-link" routerLink="/reset-password">Reset your password</a>
        }
      </div>
    </div>
  }

  <form
    class="bk-auth-form"
    [formGroup]="signinForm"
    (ngSubmit)="handleSubmit()"
    novalidate
    [attr.aria-busy]="loading"
  >
    <!-- email or username -->
    <div class="bk-field" [class.is-invalid]="showEmailError">
      <label class="bk-field__label" for="signin-email">Email or username</label>
      <input
        id="signin-email"
        class="bk-field__input"
        type="text"
        formControlName="email"
        placeholder="name@company.com"
        autocomplete="username"
        autocapitalize="none"
        autocorrect="off"
        spellcheck="false"
        [attr.aria-invalid]="showEmailError"
        [attr.aria-describedby]="showEmailError ? 'signin-email-error' : null"
      />
      @if (showEmailError) {
        <p class="bk-field__error" id="signin-email-error">
          <span class="bk-sym" aria-hidden="true">error</span>Enter your email or username.
        </p>
      }
    </div>

    <!-- password -->
    <div class="bk-field" [class.is-invalid]="showPasswordError || error?.field === 'password'">
      <label class="bk-field__label" for="signin-password">Password</label>
      <div class="bk-field__wrap">
        <input
          id="signin-password"
          class="bk-field__input"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder="Your password"
          autocomplete="current-password"
          autocapitalize="none"
          autocorrect="off"
          spellcheck="false"
          [attr.aria-invalid]="showPasswordError || error?.field === 'password'"
          [attr.aria-describedby]="
            showPasswordError ? 'signin-password-error' : error?.field === 'password' ? 'signin-error' : null
          "
          (keydown)="checkCapsLock($event)"
          (keyup)="checkCapsLock($event)"
          (blur)="capsLockOn = false"
        />
        <button
          type="button"
          class="bk-field__reveal"
          aria-controls="signin-password"
          aria-label="Show password"
          [attr.aria-pressed]="showPassword"
          (click)="togglePasswordVisibility()"
        >
          <span class="bk-sym" aria-hidden="true">{{ showPassword ? "visibility_off" : "visibility" }}</span>
        </button>
      </div>
      @if (showPasswordError) {
        <p class="bk-field__error" id="signin-password-error">
          <span class="bk-sym" aria-hidden="true">error</span>Enter your password.
        </p>
      }
      <div class="bk-auth-fieldfoot">
        <div aria-live="polite">
          @if (capsLockOn) {
            <p class="bk-auth-caps">
              <span class="bk-sym" aria-hidden="true">keyboard_capslock</span>Caps Lock is on
            </p>
          }
        </div>
        <a class="bk-auth-link bk-auth-link--quiet bk-auth-fieldfoot__end" routerLink="/reset-password">
          Forgot password?
        </a>
      </div>
    </div>

    <!-- aria-disabled, not disabled: a disabled button drops keyboard focus
         to <body>. handleSubmit ignores presses while loading. -->
    <button
      type="submit"
      class="bk-btn bk-btn--primary bk-auth-cta"
      [attr.aria-disabled]="loading || null"
      [attr.aria-busy]="loading"
    >
      {{ loading ? "Signing in…" : "Sign in" }}
    </button>
  </form>

  <p authFoot>No account yet? Ask an administrator in your organization to add you.</p>
</bk-auth-layout>
